
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Outstationcorporatecabserviceinbanglore() {



    const cardData =
    {
        keyword: '  Outstation Corporate Cab Service in Bangalore ',
        heading: 'etravo : Outstation Corporate Cab Service in Bangalore',



"headingDescription": "eTravo offers reliable Outstation Corporate Cab Services in Bangalore, designed for businesses, MNCs, and professionals who require seamless intercity travel for meetings, site visits, client engagements, and corporate trips. With GPS-enabled vehicles, experienced chauffeurs, and flexible one-way and round-trip plans, eTravo ensures safe, punctual, and comfortable long-distance travel from Bangalore to major business destinations across South India.",

"top": "Top Outstation Routes for Corporate Cab Services from Bangalore with eTravo",

"topPlaces": [
  {
    "title": "Mysore",
    "description": "A key business and heritage city near Bangalore, widely used for corporate meetings, industrial visits, and short business trips."
  },
  {
    "title": "Chennai",
    "description": "A major metro and industrial hub requiring frequent corporate travel for IT, manufacturing, and business operations."
  },
  {
    "title": "Hyderabad",
    "description": "A leading IT and business city where corporate teams frequently travel for client meetings and project collaborations."
  },
  {
    "title": "Coimbatore",
    "description": "An important industrial city in Tamil Nadu used for manufacturing, textile, and corporate business travel."
  },
  {
    "title": "Hosur",
    "description": "A fast-growing industrial belt near Bangalore with frequent corporate visits and factory inspections."
  },
  {
    "title": "Tirupati",
    "description": "A key destination for corporate travel, site visits, and business-related pilgrimage and logistics movement."
  },
  {
    "title": "Mangalore",
    "description": "A coastal business hub used for corporate travel in banking, port logistics, and industrial sectors."
  },
  {
    "title": "Pune",
    "description": "A major IT and automotive hub frequently visited for corporate meetings, conferences, and business expansion."
  },
  {
    "title": "Chikmagalur",
    "description": "A nearby destination used for corporate offsites, team outings, and business retreats."
  },
  {
    "title": "Ooty",
    "description": "A popular corporate retreat destination used for offsite meetings, training sessions, and team-building programs."
  }
],


"services": [
{
"name": "Outstation Corporate Cab Bangalore",
"description": "eTravo offers reliable outstation corporate cab services in Bangalore for smooth intercity business travel. Our service ensures comfortable long-distance journeys with professional chauffeurs and well-maintained vehicles."
},
{
"name": "Corporate Outstation Taxi Bangalore",
"description": "Our corporate outstation taxi services in Bangalore are designed for efficient and hassle-free business trips. eTravo ensures timely pickups, safe travel, and a comfortable experience for executives and teams."
},
{
"name": "Business Travel Cab Bangalore",
"description": "eTravo provides business travel cabs in Bangalore for professionals attending meetings, conferences, and site visits. Our service ensures reliable and comfortable travel for productive journeys."
},
{
"name": "Company Outstation Cab Bangalore",
"description": "eTravo offers company outstation cab services in Bangalore tailored for corporate travel needs. Our service ensures smooth and dependable intercity transportation for employees and executives."
},
{
"name": "Corporate Intercity Cab Bangalore",
"description": "Our corporate intercity cab services in Bangalore are ideal for business travel between cities. eTravo ensures punctual service and comfortable rides for corporate clients."
},
{
"name": "Office Trip Cab Bangalore",
"description": "eTravo provides office trip cab services in Bangalore for corporate outings and official travel. Our service ensures safe and well-coordinated transportation for teams."
},
{
"name": "Long Distance Corporate Taxi Bangalore",
"description": "eTravo offers long distance corporate taxi services in Bangalore for extended travel needs. Our vehicles are equipped for comfort and reliability over long routes."
},
{
"name": "Business Tour Taxi Bangalore",
"description": "Plan your business tours with eTravo’s business tour taxi services in Bangalore. We provide dependable travel solutions for meetings, site visits, and corporate expansion trips."
},
{
"name": "Corporate Travel Outstation Bangalore",
"description": "eTravo’s corporate travel outstation services in Bangalore ensure smooth and reliable transportation for business trips beyond city limits. Our service focuses on comfort and punctuality."
},
{
"name": "Outstation Company Cab Bangalore",
"description": "eTravo provides outstation company cab services in Bangalore for efficient corporate travel. Our service ensures timely pickups and professional service for intercity journeys."
},
{
"name": "Employee Outstation Cab Bangalore",
"description": "Our employee outstation cab services in Bangalore are designed for safe and comfortable workforce travel. eTravo ensures smooth travel for official trips and business visits."
},
{
"name": "Corporate Trip Taxi Bangalore",
"description": "eTravo offers corporate trip taxi services in Bangalore for business tours and official travel. Our service ensures reliable and comfortable journeys for executives and teams."
},
{
"name": "Business Cab Outstation Bangalore",
"description": "Our business cab outstation services in Bangalore provide efficient transportation for professionals traveling for work. eTravo ensures smooth and hassle-free travel experiences."
},
{
"name": "Intercity Corporate Cab Bangalore",
"description": "eTravo offers intercity corporate cab services in Bangalore for seamless travel between cities. Our service ensures reliable vehicles and professional drivers for business travel."
},
{
"name": "Travel Cab Bangalore",
"description": "eTravo provides travel cab services in Bangalore for both local and outstation needs. Our service ensures comfortable, safe, and reliable transportation for all travel requirements."
}
],
"tableData": [
["Outstation Corporate Cab Bangalore", "Corporate Outstation Taxi Bangalore"],
["Business Travel Cab Bangalore", "Company Outstation Cab Bangalore"],
["Corporate Intercity Cab Bangalore", "Office Trip Cab Bangalore"],
["Long Distance Corporate Taxi Bangalore", "Business Tour Taxi Bangalore"],
["Corporate Travel Outstation Bangalore", "Outstation Company Cab Bangalore"],
["Employee Outstation Cab Bangalore", "Corporate Trip Taxi Bangalore"],
["Business Cab Outstation Bangalore", "Intercity Corporate Cab Bangalore"],
["Travel Cab Bangalore", ""]
],



"whychoose": [
    {
      "WhyChooseheading": "Reliable Outstation Corporate Cab Service in Bangalore",
      "WhyChoosedescription": "eTravo offers professional outstation corporate cab services in Bangalore, ensuring smooth intercity travel for business meetings, client visits, and corporate tours."
    },
    {
      "WhyChooseheading": "Ideal for Business Travel and Intercity Trips",
      "WhyChoosedescription": "Outstation corporate cabs are perfect for travel from Bangalore to cities like Mysore, Chennai, Hyderabad, and Coimbatore, ensuring hassle-free and comfortable business journeys."
    },
    {
      "WhyChooseheading": "Cost-Effective Corporate Travel Solution",
      "WhyChoosedescription": "Corporate cab services help businesses control travel expenses with fixed pricing, centralized billing, and reduced administrative overhead compared to reimbursements. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "End-to-End Travel Management for Companies",
      "WhyChoosedescription": "Outstation cab providers manage route planning, vehicle allocation, tracking, and billing, offering a complete travel solution for corporate clients. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Comfortable and Productive Travel Experience",
      "WhyChoosedescription": "Employees can relax or work during travel, improving productivity and reducing fatigue during long-distance business trips. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Wide Fleet for Corporate Outstation Travel",
      "WhyChoosedescription": "From sedans and SUVs to premium vehicles, companies can choose the right vehicle for executives, teams, or client travel requirements."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Route Expertise",
      "WhyChoosedescription": "Experienced drivers ensure safe, efficient, and timely travel across highways and intercity routes, maintaining corporate service standards."
    },
    {
      "WhyChooseheading": "24/7 Support for Business Travel Needs",
      "WhyChoosedescription": "Round-the-clock support ensures seamless coordination, emergency assistance, and uninterrupted travel for corporate outstation trips."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is outstation corporate cab service in Bangalore?',
            answer: 'It is a professional cab service that provides intercity transportation for employees, executives, and business clients for meetings and corporate travel.',
        },
        {
            question: 'Which destinations are covered under outstation cab services?',
            answer: 'Common routes include Bangalore to Mysore, Chennai, Hyderabad, Coimbatore, and other major cities.',
        },
        {
            question: 'Are outstation corporate cabs cost-effective for companies?',
            answer: 'Yes, they offer fixed pricing, centralized billing, and reduced travel management costs for businesses. :contentReference[oaicite:3]{index=3}',
        },
        {
            question: 'Do outstation cab services include drivers?',
            answer: 'Yes, all corporate outstation cab services are chauffeur-driven for convenience and safety.',
        },
        {
            question: 'Can companies book cabs for business meetings and client visits?',
            answer: 'Yes, outstation cabs are widely used for meetings, conferences, and client travel.',
        },
        {
            question: 'What types of vehicles are available for outstation travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and luxury cars depending on travel needs.',
        },
        {
            question: 'Are outstation corporate cab services available 24/7?',
            answer: 'Yes, services operate round the clock for flexible business travel schedules.',
        },
        {
            question: 'Is outstation cab travel safe for employees?',
            answer: 'Yes, services include GPS tracking, verified drivers, and safety protocols for secure travel.',
        },
        {
            question: 'Can travel plans be customized for corporate trips?',
            answer: 'Yes, routes, schedules, and rental plans can be customized based on company requirements.',
        },
        {
            question: 'How can I book outstation corporate cab service in Bangalore?',
            answer: 'You can book through the service provider’s website or contact their support team for customized corporate travel solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Vinay Kumar',
        designation: 'Business Development Manager, Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s outstation corporate cab service in Bangalore is excellent. Their comfortable vehicles and punctual drivers make business travel easy and efficient.”',
    },
    {
        name: 'Ms. Shreya Nair',
        designation: 'HR Manager, Corporate Firm, Bangalore',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for intercity corporate travel. Their reliable service and flexible plans ensure smooth trips for our employees and clients.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Corporate Cab Service in Bangalore",
  "image": "https://www.etravo.in/images/keyword/outstation-corporate-cab-bangalore.jpg",
  "description": "Reliable outstation corporate cab services in Bangalore by eTravo. Ideal for business trips, intercity travel, office tours, long-distance corporate travel, and employee transport with safe and comfortable rides.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/outstation-corporate-cab-service-in-bangalore"
  }
};









    return (
        <div>
<Helmet>
  <title>Outstation Corporate Cab Service in Bangalore | Business Travel & Intercity Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book outstation corporate cab service in Bangalore with eTravo for business trips, intercity travel, office tours, and long-distance corporate transport. Safe and reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/157.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Outstationcorporatecabserviceinbanglore;